module.exports = __webpack_public_path__ + "img/thunderstorm.812accf4.png";